<template>
<v-card color='secondary' outlined>
	<v-card-text>
		<v-list-item class='px-0 '>
			<v-list-item-avatar>
				<flag :iso="item.country" />
			</v-list-item-avatar>
			<!-- <v-list-item-content> -->
				<v-list-item-title class='headline text-wrap' v-text='item.title' />
				<!-- <v-list-item-subtitle> </v-list-item-subtitle> -->
			<!-- </v-list-item-content> -->
		</v-list-item>
	</v-card-text>
</v-card>
</template>

<script>
	export default {
		name: 'CountryItem-n',
		props: ['item']
	}
</script>

<style lang="scss" scoped>

</style>